import { render } from "./VerticalTabSwitch.vue?vue&type=template&id=06d233e2&scoped=true"
import script from "./VerticalTabSwitch.vue?vue&type=script&lang=js"
export * from "./VerticalTabSwitch.vue?vue&type=script&lang=js"

import "./VerticalTabSwitch.vue?vue&type=style&index=0&id=06d233e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d233e2"]])

export default __exports__